import { render, staticRenderFns } from "./VuesticRadioButton.vue?vue&type=template&id=64d2f8a8"
import script from "./VuesticRadioButton.vue?vue&type=script&lang=js"
export * from "./VuesticRadioButton.vue?vue&type=script&lang=js"
import style0 from "./VuesticRadioButton.vue?vue&type=style&index=0&id=64d2f8a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports